import _defineProperty from "/builder/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/builder/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, command, pick, NodeExtension, ExtensionTag, isElementDomNode, omitExtraAttributes, kebabCase, invariant, ErrorConstant, replaceText, isString } from '@remirror/core';
import { DEFAULT_SUGGESTER } from '@remirror/pm/suggest';
import { ExtensionMentionAtomTheme } from '@remirror/theme';
var _excluded = ["appendText"];

var _dec, _dec2, _class, _class2;
/**
 * Options available to the [[`MentionAtomExtension`]].
 */


var MentionAtomExtension = (_dec = extension({
  defaultOptions: {
    selectable: true,
    draggable: false,
    mentionTag: 'span',
    matchers: [],
    appendText: ' ',
    suggestTag: 'span',
    disableDecorations: false,
    invalidMarks: [],
    invalidNodes: [],
    isValidPosition: function isValidPosition() {
      return true;
    },
    validMarks: null,
    validNodes: null
  },
  handlerKeyOptions: {
    onClick: {
      earlyReturnValue: true
    }
  },
  handlerKeys: ['onChange', 'onClick'],
  staticKeys: ['selectable', 'draggable', 'mentionTag', 'matchers']
}), _dec2 = command(), _dec(_class = (_class2 = /*#__PURE__*/function (_NodeExtension) {
  _inherits(MentionAtomExtension, _NodeExtension);

  var _super = _createSuper(MentionAtomExtension);

  function MentionAtomExtension() {
    _classCallCheck(this, MentionAtomExtension);

    return _super.apply(this, arguments);
  }

  _createClass(MentionAtomExtension, [{
    key: "name",
    get: function get() {
      return 'mentionAtom';
    }
  }, {
    key: "createTags",
    value: function createTags() {
      return [ExtensionTag.InlineNode, ExtensionTag.Behavior];
    }
  }, {
    key: "createNodeSpec",
    value: function createNodeSpec(extra, override) {
      var _this = this;

      var _override$parseDOM;

      var dataAttributeId = 'data-mention-atom-id';
      var dataAttributeName = 'data-mention-atom-name';
      return _objectSpread(_objectSpread({
        inline: true,
        selectable: this.options.selectable,
        draggable: this.options.draggable,
        atom: true
      }, override), {}, {
        attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
          id: {},
          label: {},
          name: {}
        }),
        parseDOM: [].concat(_toConsumableArray(this.options.matchers.map(function (matcher) {
          var _matcher$mentionTag;

          return {
            tag: "".concat((_matcher$mentionTag = matcher.mentionTag) !== null && _matcher$mentionTag !== void 0 ? _matcher$mentionTag : _this.options.mentionTag, "[").concat(dataAttributeId, "]"),
            getAttrs: function getAttrs(node) {
              if (!isElementDomNode(node)) {
                return false;
              }

              var id = node.getAttribute(dataAttributeId);
              var name = node.getAttribute(dataAttributeName);
              var label = node.textContent;
              return _objectSpread(_objectSpread({}, extra.parse(node)), {}, {
                id: id,
                label: label,
                name: name
              });
            }
          };
        })), _toConsumableArray((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])),
        toDOM: function toDOM(node) {
          var _objectSpread2;

          var _matcher$mentionClass, _matcher$mentionTag2;

          var _ref = omitExtraAttributes(node.attrs, extra),
              label = _ref.label,
              id = _ref.id,
              name = _ref.name;

          var matcher = _this.options.matchers.find(function (matcher) {
            return matcher.name === name;
          });

          var mentionClassName = matcher ? (_matcher$mentionClass = matcher.mentionClassName) !== null && _matcher$mentionClass !== void 0 ? _matcher$mentionClass : DEFAULT_MATCHER.mentionClassName : DEFAULT_MATCHER.mentionClassName;

          var attrs = _objectSpread(_objectSpread({}, extra.dom(node)), {}, (_objectSpread2 = {
            class: name ? "".concat(mentionClassName, " ").concat(mentionClassName, "-").concat(kebabCase(name)) : mentionClassName
          }, _defineProperty(_objectSpread2, dataAttributeId, id), _defineProperty(_objectSpread2, dataAttributeName, name), _objectSpread2));

          return [(_matcher$mentionTag2 = matcher === null || matcher === void 0 ? void 0 : matcher.mentionTag) !== null && _matcher$mentionTag2 !== void 0 ? _matcher$mentionTag2 : _this.options.mentionTag, attrs, label];
        }
      });
    }
    /**
     * Creates a mention atom at the  the provided range.
     *
     * A variant of this method is provided to the `onChange` handler for this
     * extension.
     *
     * @param details - the range and name of the mention to be created.
     * @param attrs - the attributes that should be passed through. Required
     * values are `id` and `label`.
     */

  }, {
    key: "createMentionAtom",
    value: function createMentionAtom(details, attrs) {
      var name = details.name,
          range = details.range;
      var validNameExists = this.options.matchers.some(function (matcher) {
        return name === matcher.name;
      }); // Check that the name is valid.

      !validNameExists ? process.env.NODE_ENV !== "production" ? invariant(false, {
        code: ErrorConstant.EXTENSION,
        message: "Invalid name '".concat(name, "' provided when creating a mention. Please ensure you only use names that were configured on the matchers when creating the `MentionAtomExtension`.")
      }) : invariant(false) : void 0;

      var appendText = attrs.appendText,
          rest = _objectWithoutProperties(attrs, _excluded);

      return replaceText({
        type: this.type,
        appendText: getAppendText(appendText, this.options.appendText),
        attrs: _objectSpread({
          name: name
        }, rest),
        range: range
      });
    }
    /**
     * Track click events passed through to the editor.
     */

  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this2 = this;

      return {
        click: function click(event, clickState) {
          // Check if this is a direct click which must be the case for atom
          // nodes.
          if (!clickState.direct) {
            return;
          }

          var nodeWithPosition = clickState.getNode(_this2.type);

          if (!nodeWithPosition) {
            return;
          }

          return _this2.options.onClick(event, nodeWithPosition);
        }
      };
    }
  }, {
    key: "createSuggesters",
    value: function createSuggesters() {
      var _this3 = this;

      var options = pick(this.options, ['invalidMarks', 'invalidNodes', 'isValidPosition', 'validMarks', 'validNodes', 'suggestTag', 'disableDecorations', 'appendText']);
      return this.options.matchers.map(function (matcher) {
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, DEFAULT_MATCHER), options), matcher), {}, {
          onChange: function onChange(props) {
            var name = props.name,
                range = props.range;
            var createMentionAtom = _this3.store.commands.createMentionAtom;

            function command(attrs) {
              createMentionAtom({
                name: name,
                range: range
              }, attrs);
            }

            _this3.options.onChange(props, command);
          }
        });
      });
    }
  }]);

  return MentionAtomExtension;
}(NodeExtension), _applyDecoratedDescriptor(_class2.prototype, "createMentionAtom", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "createMentionAtom"), _class2.prototype), _class2)) || _class);
/**
 * The default matcher to use when none is provided in options
 */

var DEFAULT_MATCHER = _objectSpread(_objectSpread({}, pick(DEFAULT_SUGGESTER, ['startOfLine', 'supportedCharacters', 'validPrefixCharacters', 'invalidPrefixCharacters'])), {}, {
  appendText: '',
  matchOffset: 1,
  suggestClassName: ExtensionMentionAtomTheme.SUGGEST_ATOM,
  mentionClassName: ExtensionMentionAtomTheme.MENTION_ATOM
});
/**
 * Get the append text value which needs to be handled carefully since it can
 * also be an empty string.
 */


function getAppendText(preferred, fallback) {
  if (isString(preferred)) {
    return preferred;
  }

  if (isString(fallback)) {
    return fallback;
  }

  return DEFAULT_MATCHER.appendText;
}

export { MentionAtomExtension };